import { useEffect, useMemo, useState } from 'react'
import logger from 'logger'


export type InAppMessageData = {
  id: string
  isRead: boolean
  createdAt: number
} & ({
  type: 'reviewPage'
  payload: {
    productId: string
  }
} | {
  type: 'singleProduct' | 'productCategory' | 'upgrade' | 'resubscribe' | 'giftSubscription' | 'shippingIssue' | 'emptyQueue' | 'candleSubscription' | 'theEdit' | 'saks'
  payload: {}
})

export const useInAppMessages = () => {
  const [ data, setData ] = useState<InAppMessageData[]>([])
  const [ isFetching, setIsFetching ] = useState(true)

  useEffect(() => {
    (async () => {
      try {
        setIsFetching(true)

        const response = await fetch('/iterable/inapp-messages')
        if (response.status !== 200) {
          return
        }

        const data = await response.json()

        setData(data)
      }
      catch (error) {
        logger.error(error)
      }
      finally {
        setIsFetching(false)
      }

    })()
  }, [])


  const unreadMessagesCount = useMemo(() => {
    if (!data) {
      return 0
    }

    return data.filter(({ isRead }) => !isRead).length
  }, [ data ])

  return {
    inAppMessages: data,
    unreadMessagesCount,
    isFetching,
  }
}

export const readInAppMessage = (messageId: string) => {
  return fetch(`/iterable/read-inapp-message?messageId=${messageId}`, { method: 'POST' })
}
